module.exports = __webpack_public_path__ + "media/smiles/sad_1-139d4f3d.svg";